<template>
  <div :class="{ 'small-wrapper': isSmall, 'normal-wrapper': !isSmall }">
    <div class="drop" @dragover.prevent @drop="onDrop">
      <label v-if="!value" class="btn" :class="{ 'disabled': !isEdit }">
        {{ inputTextHelper }}
        <input type="file" name="image" @change="onChange" :disabled="!isEdit"
          accept="image/png, image/jpg, image/jpeg">
      </label>
      <div class="hidden" v-else :class="{ 'image': true }">
        <img :src="value" alt="Image" class="img mb-4" draggable="false" />
        <!-- <p class="mb-2">{{ name }} | {{ getSize(size) }}</p> -->
        <button class="btn remove-btn" @click="removeFile" :disabled="!isEdit">Remove</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',

  props: {
    isEdit: {
      type: Boolean,
      default: true
    },
    inputTextHelper: {
      type: String,
      default: 'Select or Drop an Image'
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    maxSize: {
      type: Number,
      default: 2
    }
  },

  data() {
    return {
      image: '',
      name: '',
      size: 0,
    }
  },

  methods: {
    onDrop(e) {
      if (!e.dataTransfer.files.length) return
      e.stopPropagation()
      e.preventDefault()
      let files = e.dataTransfer.files
      this.createFile(files[0])
    },

    onChange(e) {
      let files = e.target.files
      const sizeLimit = this.maxSize * 1024 * 1024
      if (files[0].size > sizeLimit) {
        window.alert(`Image can't be more than ${this.maxSize}MB`)
      } else {
        this.createFile(files[0])
      }
    },

    createFile(file) {
      if (!file.type.match('image.*')) return alert('Select an Image!')

      this.name = file.name
      this.size = file.size
      let reader = new FileReader()
      reader.onload = (e) => this.$emit('input', e.target.result)
      reader.readAsDataURL(file)
    },

    removeFile() {
      this.$emit('input', '')
      this.name = ''
      this.size = 0
    },

    getSize(bytes) {
      if (bytes == 0) return '0.00 B'
      const e = Math.floor(Math.log(bytes) / Math.log(1024))
      return `${(bytes / Math.pow(1024, e)).toFixed(2)} ${' KMGTP'.charAt(e)}B`
    }
  }
}
</script>

<style scoped>
.normal-wrapper {
  height: 450px;
  width: 100%;
}

.small-wrapper {
  height: 200px;
  width: 100%;
}

.btn {
  background-color: #CED2D9;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  padding: 10px 0;
  position: relative;
  transition: all ease-in-out 300ms;
  width: 25%;
}

.remove-btn {
  width: 40%;
}

.disabled {
  opacity: .8;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.helper {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 0;
}

.hidden {
  display: none !important;
  height: 100%;
  text-align: center;
  width: 100%;
}

.hidden.image {
  display: inline-block !important;
}

.img {
  display: inline-block;
  height: 80%;
  max-height: 80%;
  max-width: 80%;
  width: 80%;
}

.drop {
  background-color: #ffffff;
  border: 2px dashed #ccc;
  border-radius: 2px;
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  max-height: 500px;
  max-width: 100%;
  padding: 20px;
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 760px) {
  .btn {
    width: 60% !important;
  }
}
</style>